import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RouteConfig } from 'types';
import { AccessDenied } from './AccessDenied';

interface Props extends RouteComponentProps {
  route: RouteConfig;
  isAccessible: boolean;
}

export const ProtectedRoute = ({ route, isAccessible, ...routeProps }: Props) => {
  if (!isAccessible) {
    return <AccessDenied />;
  }

  const Component = route.component;

  return <Component {...routeProps} />;
};
